export default __webpack_public_path__ + "static/media/lodgify_step10.c82f5a6c.jpg";